// extracted by mini-css-extract-plugin
export var background = "_79-0";
export var container = "_79-1";
export var contentItem = "_79-7";
export var extendedWarranty = "_79-5";
export var link = "_79-d";
export var modal = "_79-b";
export var modalCloseButton = "_79-9";
export var modalContent = "_79-3";
export var modalContentMain = "_79-6";
export var modalImageLogo = "_79-8";
export var modalLogo = "_79-a";
export var modalSideImage = "_79-4";
export var preview = "_79-c";
export var redoModal = "_79-2";